import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import HttpServiceName, { HttpService } from "../http/http.service";
import { Endpoints } from "../../shared/config/constant.module";

export interface PlantWareLossService {
    getPlantWareLoss(plantId: string, startDate: Date, endDate: Date): angular.IPromise<apsViewModels.PlantWareLossType[]>;
}

class PlantWareLossServiceImpl implements PlantWareLossService {
    private httpService: HttpService;

    constructor(httpService: HttpService) {
        this.httpService = httpService;
    }

    getPlantWareLoss(plantId: string, startDate: Date, endDate: Date): angular.IPromise<apsViewModels.PlantWareLossType[]> {
        return this.httpService.get(
            Endpoints.PLANT_WARE_LOSS_DASHBOARD,
            {
                plantId: plantId,
                startDate: startDate,
                endDate: endDate
            });
    }
}

export default angular
    .module('aps.services.plantWareLossService', [HttpServiceName])
    .service('plantWareLossService', PlantWareLossServiceImpl)
    .name;


// WEBPACK FOOTER //
// ./src/app/services/dashboard/plantWareLoss.service.ts